const Data = [
  {
    id: 1,
    category: "first-col",
    icon: "icon-briefcase",
    time: "Jun 2026 - Aug 2026",
    title: "Software Engineer Intern",
    desc: "Square",
  },
  {
    id: 2,
    category: "second-col",
    icon: "icon-briefcase",
    time: "Sep 2024 - Dec 2024",
    title: "Technical Support Specialist",
    desc: "Tulane University - Technology Connection",
  },
];

export default Data
